export default __webpack_public_path__ + "static/media/train_icon.0b85c825.svg";